'use client';

import { useEffect, useRef } from 'react';


const gsap = typeof window !== 'undefined' ? require('gsap').gsap : null;

interface PageTransitionProps {
  children: React.ReactNode;
}

export default function PageTransition({ children }: PageTransitionProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current || !gsap) return;

    // Dreamy fade + slide entrance animation
    gsap.fromTo(
      containerRef.current,
      {
        opacity: 0,
        y: 30,
        scale: 0.98,
      },
      {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 1.2,
        ease: 'power3.out',
      }
    );

    // Floating animation for dreamy effect
    gsap.to(containerRef.current, {
      y: -5,
      duration: 2.5,
      repeat: -1,
      yoyo: true,
      ease: 'sine.inOut',
    });
  }, []);

  return (
    <div ref={containerRef} className="will-change-transform">
      {children}
    </div>
  );
}
